import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import func from '../assets/func'
import HomePage from '@/views/HomePage'
import Product from '@/views/Product'
import Login from '@/views/Login'
import Register from '@/views/Register'
import RegisterSuccess from '@/views/RegisterSuccess'
import RegisterFail from '@/views/RegisterFail'
import RegisterExpired from '@/views/RegisterExpired'
import ForgetPassword from '@/views/ForgetPassword'
import ResetPassword from '@/views/ResetPassword'
import ResetFail from '@/views/ResetFail'
import ResetExpired from '@/views/ResetExpired'
import ResetSuccess from '@/views/ResetSuccess'
import Profile from '@/views/Profile'
import Job from '@/views/Job'
import Favourite from '@/views/Favourite'
import Purchase from '@/views/Purchase'
import CartPage from '@/views/CartPage'
import ShoppingCart from '@/views/ShoppingCart'
import Payment from '@/views/Payment'
import Checkout from '@/views/Checkout'
import PaymentSuccessful from '@/views/PaymentSuccessful'
import Terms from '@/views/Terms'
import Policy from '@/views/Policy'
import ReturnPolicy from '@/views/ReturnPolicy'
import Seller from '@/views/Seller'
import Chats from '@/views/Chats'
import Chatroom from '@/views/Chatroom'
import Story from '@/views/Story'
import Clothes from '@/views/Clothes'
import Ranking from '@/views/Ranking'
import NewcomerMore from '@/views/NewcomerMore'
import StoryMore from '@/views/StoryMore'
import VideoMore from '@/views/VideoMore'
import PhotoMore from '@/views/PhotoMore'
import Unlocks from '@/views/Unlocks'
import SellerBlocks from '@/views/Blocks'
// ---------- Admin ----------
import AdminLogin from '@/components/admin/AdminLogin'
import AdminPage from '@/views/AdminPage'
import MemberManagement from '@/components/admin/MemberManagement'
import SellerManagement from '@/components/admin/seller/SellerManagement'
import SellerProductStatistic from '@/components/admin/seller/SellerProductStatistic'
import SellerStatistic from '@/components/admin/seller/SellerStatistic'
import ProductManagement from '@/components/admin/ProductManagement'
import WealthManagement from '@/components/admin/WealthManagement'
import OrderManagement from '@/components/admin/OrderManagement'
import PeachManagement from '@/components/admin/PeachManagement'
import Announcement from '@/components/admin/Announcement'
import NewProduct from '@/components/admin/NewProduct'
import NewSeller from '@/components/admin/seller/NewSeller'
import NewMember from '@/components/admin/NewMember'
import AdminTools from '@/components/admin/AdminTools'
import Audit from '@/components/admin/Audit'
import Banner from '@/components/admin/Banner'
import Ban from '@/components/admin/Ban'
import Remittance from '@/components/admin/Remittance'
import NewRemit from '@/components/admin/NewRemit'
import ChatGift from '@/components/admin/chat/Gift'
import ChatKeyword from '@/components/admin/chat/Keyword'
import ChatViolation from '@/components/admin/chat/Violation'
import ChatNewViolation from '@/components/admin/chat/NewViolation'
import ChatRecord from '@/components/admin/chat/Record'
// ---------- Seller ----------
import SellerPortal from '@/views/SellerPortal'
import Dashboard from '@/components/portal/Dashboard'
import Setting from '@/components/portal/Setting'
import MemberBlocks from '@/components/portal/Blocks'
import Profit from '@/components/portal/Profit'
import Contribution from '@/components/portal/Contribution'
import MonthlyProfit from '@/components/portal/MonthlyProfit'
import Portal_Chats from '@/components/portal/Chats'
import Portal_Chatroom from '@/components/portal/Chatroom'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { login: true, keepAlive: true },
  },
  {
    path: '/product/:id',
    name: 'Product',
    component: Product,
    meta: { login: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登入' }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { title: '註冊' }
  },
  {
    path: '/register/success',
    name: 'RegisterSuccess',
    component: RegisterSuccess,
    meta: { title: '註冊成功' }
  },
  {
    path: '/register/fail',
    name: 'RegisterFail',
    component: RegisterFail,
    meta: { title: '註冊失敗' }
  },
  {
    path: '/register/expired',
    name: 'RegisterExpired',
    component: RegisterExpired,
    meta: { title: '連結已失效' }
  },
  {
    path: '/forget',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: { title: '忘記密碼' }
  },
  {
    path: '/forget/reset',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { title: '重置密碼' }
  },
  {
    path: '/forget/fail',
    name: 'ResetFail',
    component: ResetFail,
    meta: { title: '重置失敗' }
  },
  {
    path: '/forget/expired',
    name: 'ResetExpired',
    component: ResetExpired,
    meta: { title: '連結已失效' }
  },
  {
    path: '/forget/success',
    name: 'ResetSuccess',
    component: ResetSuccess,
    meta: { title: '重置成功' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { login: true }
  },
  {
    path: '/job/:id',
    name: 'Job',
    component: Job,
    meta: { login: true },
  },
  {
    path: '/purchase',
    name: 'Purchase',
    component: Purchase,
    meta: { title: '購買清單' },
    meta: { login: true }
  },
  {
    path: '/seller/:id',
    name: 'Seller',
    component: Seller,
    meta: { login: true },
  },
  {
    path: '/chats',
    name: 'Chats',
    component: Chats,
    meta: { title: '聊天' },
    meta: { login: true }
  },
  {
    path: '/chat/:id?',
    name: 'Chatroom',
    component: Chatroom,
    props: true,
    meta: { login: true }
  },
  {
    path: '/story/:id',
    name: 'Story',
    component: Story,
    props: true,
    meta: { login: true },
  },
  {
    path: '/category/clothes',
    name: 'Clothes',
    component: Clothes,
    meta: { title: '原咮衣物', login: true },
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: Ranking,
    meta: { title: '排行榜', login: true }
  },
  {
    path: '/category/newcomer',
    name: 'NewcomerMore',
    component: NewcomerMore,
    meta: { title: '新人榜', login: true }
  },
  {
    path: '/category/story',
    name: 'StoryMore',
    component: StoryMore,
    meta: { title: '限時動態', login: true }
  },
  {
    path: '/category/video',
    name: 'VideoMore',
    component: VideoMore,
    meta: { title: '長片', login: true }
  },
  {
    path: '/category/photo',
    name: 'PhotoMore',
    component: PhotoMore,
    meta: { title: '寫真', login: true }
  },
  {
    path: '/shoppingcart',
    component: CartPage,
    meta: { login: true },
    children: [
      {
        path: '/',
        name: 'ShoppingCart',
        meta: { title: '購物車' },
        component: ShoppingCart
      },
      {
        path: 'payment',
        name: 'Payment',
        meta: { title: '付款方式' },
        component: Payment
      },
      {
        path: 'checkout',
        name: 'Checkout',
        meta: { title: '立即付款' },
        component: Checkout
      },
      {
        path: 'success',
        name: 'PaymentSuccessful',
        meta: { title: '購買成功' },
        component: PaymentSuccessful
      },
    ]
  },
  {
    path: '/terms',
    name: 'Terms',
    meta: { title: '服務條款' },
    component: Terms
  },
  {
    path: '/policy',
    name: 'Policy',
    meta: { title: '隱私權政策' },
    component: Policy
  },
  {
    path: '/returnpolicy',
    name: 'ReturnPolicy',
    meta: { title: '退貨條款' },
    component: ReturnPolicy
  },
  {
    path: '/unlocks',
    name: 'Unlocks',
    meta: { title: '解鎖項目', login: true },
    component: Unlocks
  },
  {
    path: '/blocks',
    name: 'SellerBlocks',
    meta: { title: '封鎖主播', login: true },
    component: SellerBlocks
  },
  {
    path: '/admin',
    component: AdminPage,
    name: 'AdminLogin',
    meta: { adminLogin: true },
    children: [
    {
        path: 'member',
        name: 'MemberManagement',
        component: MemberManagement,
      },
      {
        path: 'seller',
        name: 'SellerManagement',
        component: SellerManagement,
      },
      {
        path: 'seller/product/statistic',
        name: 'SellerProductStatistic',
        component: SellerProductStatistic,
      },
      {
        path: 'seller/statistic',
        name: 'SellerStatistic',
        component: SellerStatistic,
      },
      {
        path: 'seller/:id',
        name: 'EditSeller',
        component: NewSeller,
      },
      {
        path: 'product',
        name: 'ProductManagement',
        component: ProductManagement,
      },
      {
        path: 'wealth',
        name: 'WealthManagement',
        component: WealthManagement,
      },
      {
        path: 'product/:id',
        name: 'EditProduct',
        component: NewProduct,
      },
      {
        path: 'newProduct',
        name: 'NewProduct',
        component: NewProduct,
      },
      {
        path: 'newSeller',
        name: 'NewSeller',
        component: NewSeller,
      },
      {
        path: 'member/:id',
        name: 'EditMember',
        component: NewMember,
      },
      {
        path: 'order',
        name: 'OrderManagement',
        component: OrderManagement
      },
      {
        path: 'peach',
        name: 'PeachManagement',
        component: PeachManagement
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: Announcement
      },
      {
        path: 'tools',
        name: 'AdminTools',
        component: AdminTools
      },
      {
        path: 'audit',
        name: 'Audit',
        component: Audit
      },
      {
        path: 'banner',
        name: 'Banner',
        component: Banner
      },
      {
        path: 'ban',
        name: 'Ban',
        component: Ban
      },
      {
        path: 'remittance',
        name: 'Remittance',
        component: Remittance
      },
      {
        path: 'newRemit',
        name: 'NewRemit',
        component: NewRemit
      },
      {
        path: 'chat/gift',
        name: 'ChatGift',
        component: ChatGift
      },
      {
        path: 'chat/keyword',
        name: 'ChatKeyword',
        component: ChatKeyword
      },
      {
        path: 'chat/violation',
        name: 'ChatViolation',
        component: ChatViolation
      },
      {
        path: 'chat/newViolation',
        name: 'ChatNewViolation',
        component: ChatNewViolation
      },
      {
        path: 'chat/violation/:id',
        name: 'ChatEditViolation',
        component: ChatNewViolation
      },
      {
        path: 'chat/record',
        name: 'ChatRecord',
        component: ChatRecord
      }
    ]
  },
  {
    path: '/portal',
    component: SellerPortal,
    name: 'SellerPortal',
    redirect: '/portal/dashboard',
    meta: { sellerLogin: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'setting',
        name: 'Setting',
        component: Setting
      },
      {
        path: 'blocks',
        name: 'MemberBlocks',
        component: MemberBlocks
      },
      {
        path: 'profit',
        name: 'Profit',
        component: Profit
      },
      {
        path: 'contribution',
        name: 'Contribution',
        component: Contribution
      },
      {
        path: 'profit/monthly',
        name: 'MonthlyProfit',
        component: MonthlyProfit
      },
      {
        path: 'chats',
        name: 'Portal_Chats',
        component: Portal_Chats
      },
      {
        path: 'chatroom/:room_id?',
        name: 'Portal_Chatroom',
        component: Portal_Chatroom,
        props: true
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if(from.fullPath != store.state.global.prev_page.fullPath) {
    store.dispatch('global/setPrevPage', from.name ? {...from, force: null} : {})
  }
  if(to.matched.some(record => record.meta.adminLogin) ) {
    if(store.getters['admin/isLogin'] || to.name == 'AdminLogin') {
      next()
    }
    else {
      store.state.global.prev_page.force = to
      next('/admin')
    }
  } 
  else if(to.matched.some(record => record.meta.sellerLogin) ) {
    if(store.getters['seller/isLogin']) {
      next()
    }
    else {
      store.state.global.prev_page.force = to
      next('/login?type=seller')
    }
  } 
  else if(to.matched.some(record => record.meta.login)) {
    // 允許賣家存取商品預覽頁面
    if(store.getters['user/isLogin'] || store.getters['seller/isLogin']) {
      next()
    }
    else if(store.state.user.token) {
      store.dispatch('user/getUserInformation').then(() => {
        next()
      }).catch(() => {
        next('/login')
      })

    }
    else {
      store.state.global.prev_page.force = to
      next('/login')
    }
  }
  else {
    next()
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if(to.meta && to.meta.title) {
      document.title = to.meta.title + ` - ${process.env.VUE_APP_TITLE}`
    }
    else {
      document.title = process.env.VUE_APP_TITLE
    }
  })
})

export default router
